// src/pages/HomePage.tsx

import { useNavigate } from 'react-router-dom';

export function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4 sm:p-6">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl p-4 sm:p-8">
        <div className="text-center">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            ER Triage Sensor
          </h1>

          <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8 px-2">
            Point camera at patient and capture vital signs in 10 seconds
          </p>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 sm:p-6 mb-6 sm:mb-8">
            <h2 className="text-lg sm:text-xl font-semibold text-blue-900 mb-3">
              Features
            </h2>
            <ul className="text-left text-sm sm:text-base text-gray-700 space-y-2">
              <li className="flex items-start">
                <span className="mr-2 flex-shrink-0">•</span>
                <span>Heart rate and respiratory rate via camera</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2 flex-shrink-0">•</span>
                <span>Posture detection (standing/sitting/collapsed)</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2 flex-shrink-0">•</span>
                <span>Respiratory effort scoring</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2 flex-shrink-0">•</span>
                <span>Skin features (pallor & diaphoresis)</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2 flex-shrink-0">•</span>
                <span>Eye openness and pain expression</span>
              </li>
            </ul>
          </div>

          <button
            onClick={() => navigate('/measure')}
            className="w-full px-6 sm:px-8 py-3 sm:py-4 bg-blue-600 text-white text-lg sm:text-xl font-semibold rounded-lg hover:bg-blue-700 active:bg-blue-800 transition duration-200 shadow-lg hover:shadow-xl touch-manipulation"
          >
            Start Triage
          </button>

          <p className="text-xs sm:text-sm text-gray-500 mt-4 sm:mt-6 px-2">
            Note: This is a research prototype. Not for clinical use.
          </p>
        </div>
      </div>
    </div>
  );
}
